import { useState } from "react";

export const LoadingImage = ({ src, alt = "", className = "", fallback }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  if (error || !src) return fallback || null;

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {!loaded && <div className={`absolute inset-0 img-shimmer rounded-[inherit]`} />}
      <img
        src={src}
        alt={alt}
        className={`w-full h-full object-cover transition-opacity duration-300 ${loaded ? "opacity-100" : "opacity-0"}`}
        onLoad={() => setLoaded(true)}
        onError={() => setError(true)}
      />
    </div>
  );
};
